import { Injectable, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
//import {Connection} from "@angular/http";
//import {Network} from "@ionic-native/network";
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
//import { SecureStorage, SecureStorageObject } from '@ionic-native/secure-storage';


declare var navigator: any;
//declare var Connection: any;


@Injectable()
export class PostService {
  userEmail: any;
  userLocation: string;
  userName: string;



  //apiUrl="http://mfcslcif.cloudapp.net/MFCSL_Development2/api/";
  apiUrl = "https://mmfss-econnectweb.azurewebsites.net/api/";
  data: any = {};
  networkState: any;
  public loading: any;
  public detailValue: any;
  public messageSource = new BehaviorSubject<any>(this.detailValue);
  public networkmessageSource = new BehaviorSubject<any>(this.networkState)
  state: any;
  public tokenid: any;
  abc: any;

  constructor(public http: HttpClient, ) {

    this.detailValue = this.messageSource.asObservable();
    this.networkState = this.networkmessageSource.asObservable();
    this.networkState.subscribe((data) => {
      this.state = data;
    });

  }



  getCurrentTime() {
    // if (this.state) {
    return new Promise((resolve, reject) => {
      this.getHeaders().then((authtoken: any) => {
        this.http.get(this.apiUrl, { headers: authtoken, observe: 'response' })
          .subscribe(res => {
            // this.refreshToken(res.headers.get('authtoken'));
            resolve(res.body);
          }, (err) => {
            reject(err.statusText);
          });
      });
    })
    // } else {
    //   return new Promise((reject) => {
    //     throw new Error('No Internet Connection!');
    //   });
    // }
  }

  getData(postUrl, params?) {

    //  if (this.state) {
    console.log('PARAM', params);

    return new Promise((resolve, reject) => {

        this.http.get(postUrl, { headers: { 'Content-Type': 'application/json' }})
        .subscribe((res: any) => {

          resolve(res);
        }, (err) => {
          if (err.status === 401) {
           // this.event.publish('user:logout');
            reject('Your session has been expired! Please login again.');
          }
          if (err.status == 500) {
            reject("Internal Server Error!");
          }
        });
      }).catch((err) => {
        console.log("promise err: ", err);
      })


    // } else {

    //   return new Promise((reject) => {
    //     throw new Error('No Internet Connection!');
    //   });

    // }
  }


  getHeaders() {
    let promise = new Promise((resolve) => {
        resolve({ 'Content-Type': 'application/json', 'platform':'m' });
    });
    return promise;
    // return { 'Content-Type': 'application/json' }
  }



  dismissLoading() {
    this.loading.dismiss();
  }
  // savetoken(data) {
  //   this.userToken = data;
  //   console.log('TOKEN', this.userToken);
  // }



}
